export enum LookupMode {
    Standard = 'standard',
    DocumentTemplate = 'documenttemplate',
}
